import { useState } from "react"
import { PiCheckCircleFill } from "react-icons/pi"
import { MdRadioButtonUnchecked } from "react-icons/md"
import Button from '../../../shared/components/Button/Button'
import api from '../../../utils/api'
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
/* form */
import Input from "../../../shared/components/form/input"
import Checkbox from "../../../shared/components/form/checkbox"
import ToggleSwitch from "../../../shared/components/form/ToggleSwitch"
import Modal from "../../../shared/modal/Modal"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import "./FormSystemUser.css"

//img
import calendarImg from "../img/calendar.jpg"
import clientImg from "../img/client.jpg"
import generatorImg from "../img/generator.jpg"
import serviceOrderImg from "../img/service-order.jpg"
import calendarServiceImg from "../img/calendar-service.jpg"
import regionsImg from "../img/regioes.webp"
import checklistImg from "../img/checklist.jpg"
import historicImg from "../img/historic.jpg"
import backupImg from "../img/backup.jpg"

function FormSystemUser({ handleSubmit, userData, btnText, btCancelAction, title, changePassword, permissionData, mode = 'both' }) {
  const [myPermission] = useState(permissionData || {})
  const [user, setUser] = useState(userData || {})
  const [permission, setPermission] = useState(userData?.permission || {})
  const [newPwd, setNewPwd] = useState({})
  const [selectedTab, setSelectedTab] = useState(mode === 'permission' ? 'permission' : 'user')

  const showInfo = mode === 'both' ? selectedTab === 'user' : mode === 'info'
  const showPermission = mode === 'both' ? selectedTab === 'permission' : mode === 'permission'

  const [modalChangePwd, setModalChangePwd] = useState(false)
  const [token] = useState(localStorage.getItem('token') || '')
  const { setFlashMessage } = useFlashMessage()

  //password validation states
  const [lowerValidated, setLowerValidated] = useState(false)
  const [upperValidated, setUpperValidated] = useState(false)
  const [numberValidated, setNumberValidated] = useState(false)
  const [specialValidated, setSpecialValidated] = useState(false)
  const [lengthValidated, setLengthValidated] = useState(false)

  const handleChangePwd = (e) => {
    const value = e.target.value
    setUser(prev => ({ ...prev, [e.target.name]: value }))
    validatePwd(value)
  }

  const handleChangePermission = (e) => {
    setPermission(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleChangeTS = (name, value) => {
    setPermission(prev => ({ ...prev, [name]: value }))
  }

  const handleChangeNewPwd = (e) => {
    const value = e.target.value
    setNewPwd(prev => ({ ...prev, [e.target.name]: value }))
    if (e.target.name !== "confirmPassword") {
      validatePwd(value)
    }
  }

  function validatePwd(pwd) {
    const lower = new RegExp('(?=.*[a-z])')
    const upper = new RegExp('(?=.*[A-Z])')
    const number = new RegExp('(?=.*[0-9])')
    const special = new RegExp('(?=.*[!@#\$%\^&\*])')
    const length = new RegExp('(?=.{8,})')

    setLowerValidated(lower.test(pwd))
    setUpperValidated(upper.test(pwd))
    setNumberValidated(number.test(pwd))
    setSpecialValidated(special.test(pwd))
    setLengthValidated(length.test(pwd))
  }

  function handleChange(e) {
    setUser(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  function handleChangeCheckbox(name, value) {
    setUser(prev => ({ ...prev, [name]: value }))
  }

  async function submitChangePwd() {
    let msgType = 'success'

    const data = await api.patch(`/user/changepwd/${user._id}`, newPwd, {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` }
    }).then((response) => {
      setModalChangePwd(false)
      return response.data
    }).catch((err) => {
      msgType = 'error'
      return err.response.data
    })

    setFlashMessage(data.message, msgType)
  }

  function submit(e) {
    e.preventDefault()
    handleSubmit({ ...user, permission })
  }

  const PwdValidationList = () => (
    <div className="validation-box form-group">
      <div className={upperValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{upperValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos uma letra maiúscula</div>
      <div className={lowerValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{lowerValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos uma letra minúscula</div>
      <div className={numberValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{numberValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos um número</div>
      <div className={specialValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{specialValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos um caractere especial</div>
      <div className={lengthValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{lengthValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos 8 caracteres</div>
    </div>
  )

  return (
    <>
      <FormLayout requiredLegend
        title={title}
        onSubmit={submit}
        actions={
          <>
            <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
            {btCancelAction && (
              <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
            )}
          </>
        }
      >
        {mode === 'both' && (
          <div className="su-tab-row">
            <button type="button" className={`su-tab ${selectedTab === "user" ? "su-tab-active" : ""}`} onClick={() => setSelectedTab("user")}>
              Usuário
            </button>
            <button type="button" className={`su-tab ${selectedTab === "permission" ? "su-tab-active" : ""}`} onClick={() => setSelectedTab("permission")}>
              Permissões
            </button>
          </div>
        )}

        {showInfo && (
          <FormSection label="Dados do Usuário">
            {changePassword !== 'disable' && (
              <div className="form-group">
                <Checkbox
                  text="Usuário desabilitado"
                  name="disabledUser"
                  handleOnChange={() => handleChangeCheckbox("disabledUser", !user.disabledUser)}
                  check={user.disabledUser || false}
                />
              </div>
            )}

            <div className="form-group">
              <Checkbox
                text="Técnico (poderá preencher checklists de Ordem de Serviço)"
                name="technician"
                handleOnChange={() => handleChangeCheckbox("technician", !user.technician)}
                check={user.technician || false}
              />
            </div>

            <div className="fl-row">
              <div className="fl-col-wide form-group">
                <Input required text="Nome completo" type="text" name="name" placeholder="Digite o nome do usuário" handleOnChange={handleChange} value={user.name || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input required text="E-mail" type="email" name="email" placeholder="Digite o e-mail" handleOnChange={handleChange} value={user.email || ''} />
              </div>
            </div>

            <div className="fl-row">
              <div className="fl-col-mid form-group">
                <Input required text="Data de Nascimento" type="date" name="birth" handleOnChange={handleChange} value={user.birth || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input required text="Telefone WhatsApp" type="tel" name="phone" placeholder="Digite o telefone" handleOnChange={handleChange} value={user.phone || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input required text="Usuário" type="text" name="userName" placeholder="Usuário de acesso" handleOnChange={handleChange} value={user.userName || ''} />
              </div>
            </div>

            {changePassword === 'disable' ? (
              <>
                <div className="fl-row">
                  <div className="fl-col-mid form-group">
                    <Input required text="Senha" type="password" name="password" placeholder="Digite a senha" handleOnChange={handleChangePwd} value={user.password || ''} />
                  </div>
                  <div className="fl-col-mid form-group">
                    <Input required text="Confirmar senha" type="password" name="confirmPassword" placeholder="Repita a senha" handleOnChange={handleChange} value={user.confirmPassword || ''} />
                  </div>
                </div>
                <PwdValidationList />
              </>
            ) : (
              <div className="form-group">
                <Button variant="edit" onClick={() => setModalChangePwd(true)}>Alterar senha</Button>
              </div>
            )}

            {myPermission.group === "DEV_MASTER" && (
              <div className="fl-row">
                <div className="fl-col-mid form-group">
                  <Input text="Grupo" type="text" name="group" placeholder="Digite o grupo de acesso" handleOnChange={handleChangePermission} value={permission.group || ''} />
                </div>
              </div>
            )}
          </FormSection>
        )}

        {showPermission && (
          <>
            <FormSection label="Clientes">
              <div className="su-permission-box">
                <img className="su-permission-img" src={clientImg} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Clientes</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="client_View" value={permission.client_View} handleOnChange={() => handleChangeTS("client_View", !permission.client_View)} />
                    <ToggleSwitch text="Criar" name="client_Create" value={permission.client_Create} handleOnChange={() => handleChangeTS("client_Create", !permission.client_Create)} />
                    <ToggleSwitch text="Editar" name="client_Edit" value={permission.client_Edit} handleOnChange={() => handleChangeTS("client_Edit", !permission.client_Edit)} />
                    <ToggleSwitch text="Excluir" name="client_Delete" value={permission.client_Delete} handleOnChange={() => handleChangeTS("client_Delete", !permission.client_Delete)} />
                  </div>
                  <p className="su-permission-subtitle">Vínculos do cliente</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Ver Geradores" name="clientGenerator_View" value={permission.clientGenerator_View} handleOnChange={() => handleChangeTS("clientGenerator_View", !permission.clientGenerator_View)} />
                    <ToggleSwitch text="Editar Geradores" name="clientGenerator_Edit" value={permission.clientGenerator_Edit} handleOnChange={() => handleChangeTS("clientGenerator_Edit", !permission.clientGenerator_Edit)} />
                    <ToggleSwitch text="Ver Vendedores" name="clientSeller_View" value={permission.clientSeller_View} handleOnChange={() => handleChangeTS("clientSeller_View", !permission.clientSeller_View)} />
                    <ToggleSwitch text="Editar Vendedores" name="clientSeller_Edit" value={permission.clientSeller_Edit} handleOnChange={() => handleChangeTS("clientSeller_Edit", !permission.clientSeller_Edit)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Meus Clientes</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="myClient_View" value={permission.myClient_View} handleOnChange={() => handleChangeTS("myClient_View", !permission.myClient_View)} />
                    <ToggleSwitch text="Criar" name="myClient_Create" value={permission.myClient_Create} handleOnChange={() => handleChangeTS("myClient_Create", !permission.myClient_Create)} />
                    <ToggleSwitch text="Editar" name="myClient_Edit" value={permission.myClient_Edit} handleOnChange={() => handleChangeTS("myClient_Edit", !permission.myClient_Edit)} />
                    <ToggleSwitch text="Excluir" name="myClient_Delete" value={permission.myClient_Delete} handleOnChange={() => handleChangeTS("myClient_Delete", !permission.myClient_Delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Geradores">
              <div className="su-permission-box">
                <img className="su-permission-img" src={generatorImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="generator_View" value={permission.generator_View} handleOnChange={() => handleChangeTS("generator_View", !permission.generator_View)} />
                  <ToggleSwitch text="Criar" name="generator_Create" value={permission.generator_Create} handleOnChange={() => handleChangeTS("generator_Create", !permission.generator_Create)} />
                  <ToggleSwitch text="Editar" name="generator_Edit" value={permission.generator_Edit} handleOnChange={() => handleChangeTS("generator_Edit", !permission.generator_Edit)} />
                  <ToggleSwitch text="Excluir" name="generator_Delete" value={permission.generator_Delete} handleOnChange={() => handleChangeTS("generator_Delete", !permission.generator_Delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Regiões">
              <div className="su-permission-box">
                <img className="su-permission-img" src={regionsImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="region_View" value={permission.region_View} handleOnChange={() => handleChangeTS("region_View", !permission.region_View)} />
                  <ToggleSwitch text="Criar" name="region_Create" value={permission.region_Create} handleOnChange={() => handleChangeTS("region_Create", !permission.region_Create)} />
                  <ToggleSwitch text="Editar" name="region_Edit" value={permission.region_Edit} handleOnChange={() => handleChangeTS("region_Edit", !permission.region_Edit)} />
                  <ToggleSwitch text="Excluir" name="region_Delete" value={permission.region_Delete} handleOnChange={() => handleChangeTS("region_Delete", !permission.region_Delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Serviços e Prazos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={calendarImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="serviceExp_View" value={permission.serviceExp_View} handleOnChange={() => handleChangeTS("serviceExp_View", !permission.serviceExp_View)} />
                  <ToggleSwitch text="Criar" name="serviceExp_Create" value={permission.serviceExp_Create} handleOnChange={() => handleChangeTS("serviceExp_Create", !permission.serviceExp_Create)} />
                  <ToggleSwitch text="Editar" name="serviceExp_Edit" value={permission.serviceExp_Edit} handleOnChange={() => handleChangeTS("serviceExp_Edit", !permission.serviceExp_Edit)} />
                  <ToggleSwitch text="Excluir" name="serviceExp_Delete" value={permission.serviceExp_Delete} handleOnChange={() => handleChangeTS("serviceExp_Delete", !permission.serviceExp_Delete)} />
                  <ToggleSwitch text="Alertas" name="serviceExp_Alert" value={permission.serviceExp_Alert} handleOnChange={() => handleChangeTS("serviceExp_Alert", !permission.serviceExp_Alert)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Ordens de Serviço">
              <div className="su-permission-box">
                <img className="su-permission-img" src={serviceOrderImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar (Cadastro)" name="serviceOrder_View" value={permission.serviceOrder_View} handleOnChange={() => handleChangeTS("serviceOrder_View", !permission.serviceOrder_View)} />
                  <ToggleSwitch text="Criar" name="serviceOrder_Create" value={permission.serviceOrder_Create} handleOnChange={() => handleChangeTS("serviceOrder_Create", !permission.serviceOrder_Create)} />
                  <ToggleSwitch text="Editar" name="serviceOrder_Edit" value={permission.serviceOrder_Edit} handleOnChange={() => handleChangeTS("serviceOrder_Edit", !permission.serviceOrder_Edit)} />
                  <ToggleSwitch text="Excluir" name="serviceOrder_Delete" value={permission.serviceOrder_Delete} handleOnChange={() => handleChangeTS("serviceOrder_Delete", !permission.serviceOrder_Delete)} />
                  <ToggleSwitch text="Ver Em Aberto" name="serviceOrderOpen_View" value={permission.serviceOrderOpen_View} handleOnChange={() => handleChangeTS("serviceOrderOpen_View", !permission.serviceOrderOpen_View)} />
                  <ToggleSwitch text="Ver Em Análise" name="serviceOrderReview_View" value={permission.serviceOrderReview_View} handleOnChange={() => handleChangeTS("serviceOrderReview_View", !permission.serviceOrderReview_View)} />
                  <ToggleSwitch text="Ver Concluídas" name="serviceOrderConcluded_View" value={permission.serviceOrderConcluded_View} handleOnChange={() => handleChangeTS("serviceOrderConcluded_View", !permission.serviceOrderConcluded_View)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Checklist">
              <div className="su-permission-box">
                <img className="su-permission-img" src={checklistImg} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Grupos de Checklist</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="checklistGroup_View" value={permission.checklistGroup_View} handleOnChange={() => handleChangeTS("checklistGroup_View", !permission.checklistGroup_View)} />
                    <ToggleSwitch text="Criar" name="checklistGroup_Create" value={permission.checklistGroup_Create} handleOnChange={() => handleChangeTS("checklistGroup_Create", !permission.checklistGroup_Create)} />
                    <ToggleSwitch text="Editar" name="checklistGroup_Edit" value={permission.checklistGroup_Edit} handleOnChange={() => handleChangeTS("checklistGroup_Edit", !permission.checklistGroup_Edit)} />
                    <ToggleSwitch text="Excluir" name="checklistGroup_Delete" value={permission.checklistGroup_Delete} handleOnChange={() => handleChangeTS("checklistGroup_Delete", !permission.checklistGroup_Delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Itens de Checklist</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="checklistItem_View" value={permission.checklistItem_View} handleOnChange={() => handleChangeTS("checklistItem_View", !permission.checklistItem_View)} />
                    <ToggleSwitch text="Criar" name="checklistItem_Create" value={permission.checklistItem_Create} handleOnChange={() => handleChangeTS("checklistItem_Create", !permission.checklistItem_Create)} />
                    <ToggleSwitch text="Editar" name="checklistItem_Edit" value={permission.checklistItem_Edit} handleOnChange={() => handleChangeTS("checklistItem_Edit", !permission.checklistItem_Edit)} />
                    <ToggleSwitch text="Excluir" name="checklistItem_Delete" value={permission.checklistItem_Delete} handleOnChange={() => handleChangeTS("checklistItem_Delete", !permission.checklistItem_Delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Procedimentos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="procedure_View" value={permission.procedure_View} handleOnChange={() => handleChangeTS("procedure_View", !permission.procedure_View)} />
                    <ToggleSwitch text="Criar" name="procedure_Create" value={permission.procedure_Create} handleOnChange={() => handleChangeTS("procedure_Create", !permission.procedure_Create)} />
                    <ToggleSwitch text="Editar" name="procedure_Edit" value={permission.procedure_Edit} handleOnChange={() => handleChangeTS("procedure_Edit", !permission.procedure_Edit)} />
                    <ToggleSwitch text="Excluir" name="procedure_Delete" value={permission.procedure_Delete} handleOnChange={() => handleChangeTS("procedure_Delete", !permission.procedure_Delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Quadro de Manutenção">
              <div className="su-permission-box">
                <img className="su-permission-img" src={calendarServiceImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="schedule_View" value={permission.schedule_View} handleOnChange={() => handleChangeTS("schedule_View", !permission.schedule_View)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Histórico do Sistema">
              <div className="su-permission-box">
                <img className="su-permission-img" src={historicImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="historic_View" value={permission.historic_View} handleOnChange={() => handleChangeTS("historic_View", !permission.historic_View)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Backup">
              <div className="su-permission-box">
                <img className="su-permission-img" src={backupImg} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="backup_View" value={permission.backup_View} handleOnChange={() => handleChangeTS("backup_View", !permission.backup_View)} />
                  <ToggleSwitch text="Gerar Backup" name="backup_Create" value={permission.backup_Create} handleOnChange={() => handleChangeTS("backup_Create", !permission.backup_Create)} />
                </div>
              </div>
            </FormSection>
          </>
        )}
      </FormLayout>

      <Modal
        modalStatus={modalChangePwd}
        changeStatus={setModalChangePwd}
        w={40}
        h={60}
        content={
          <div className="su-change-pwd">
            <p className="su-change-pwd-title">Digite uma nova senha</p>
            <div className="form-group">
              <Input text="Senha" type="password" name="password" placeholder="Digite a senha" handleOnChange={handleChangeNewPwd} value={newPwd.password || ''} />
            </div>
            <PwdValidationList />
            <div className="form-group">
              <Input text="Confirmar senha" type="password" name="confirmPassword" placeholder="Repita a senha" handleOnChange={handleChangeNewPwd} value={newPwd.confirmPassword || ''} />
            </div>
            <div className="form-group">
              <Button variant="save" onClick={submitChangePwd}>Salvar</Button>
            </div>
          </div>
        }
      />
    </>
  )
}

export default FormSystemUser
